import { render } from "./DeviceImagesEditComponent.vue?vue&type=template&id=56f97062&scoped=true"
import script from "./DeviceImagesEditComponent.vue?vue&type=script&lang=js"
export * from "./DeviceImagesEditComponent.vue?vue&type=script&lang=js"

import "./DeviceImagesEditComponent.vue?vue&type=style&index=0&id=56f97062&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f97062"]])

export default __exports__